exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner[data-v-5fbd5a0d]{padding:0 15px}\n", ""]);

// exports
